function validateStep1(values) {
  const errors = {};

  // First Name
  if (!values.firstname) {
    errors.firstname = 'First Name is required';
  }

  // Last Name
  if (!values.lastname) {
    errors.lastname = 'Last Name is required';
  }

  // Phone number (basic check for digits and some punctuation)
  if (!values.phone) {
    errors.phone = 'Phone Number is required';
  } else if (!/^[0-9-() ]{7,20}$/.test(values.phone)) {
    errors.phone = 'Enter a valid phone number';
  }

  // Email
  if (!values.email) {
    errors.email = 'Email Address is required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = 'Enter a valid email address';
  }

  // Company Name
  if (!values.company_name) {
    errors.company_name = 'Company Name is required';
  }

  return errors;
}

export default validateStep1;
